<template>
    <div class="w100 bgGrey">
        <article class="wContent center infor-detail-box">
            <div class="mw-modular-box">
                <el-row :gutter="20">
                    <el-col :span="16">
                        <div class="grid-content bgWhite p20" style="min-height: 1008px;">
                            <h1 style="word-break: break-all;">{{ detail_info.length > 0 ? detail_info[0]['the_title'] : '' }}</h1>
                            <div class="content-box mw-modular-box">
                                <div class="content-left textCenter">
                                    <p class="fontLight font14">— 分享 —</p>
                                    <svg class="icon font20 pointer make-icon" aria-hidden="true" style="padding-top: 15px;" @click="showDetailCode()">
                                        <use xlink:href="#icon-weixin" ></use>
                                        <use xlink:href="#icon-weixin-copy" class="use"></use>
                                    </svg><br>
                                    <svg class="icon font20 pointer make-icon" aria-hidden="true" style="padding-top: 15px;" @click="shareToqq($event)">
                                        <use xlink:href="#icon-qq" ></use>
                                        <use xlink:href="#icon-qq-copy" class="use"></use>
                                    </svg><br>
                                    <p class="fontLight font14 mw-modular-box">— 收藏 —</p>
                                    <svg class="icon font20 pointer make-icon" aria-hidden="true" @click="handleCollect()">
                                        <use xlink:href="#icon-shoucang" ></use>
                                        <use xlink:href="#icon-shoucang-copy" class="use" :class="{show: isCollect}"></use>
                                    </svg><br>
                                </div>

                                <el-dialog
                                title=""
                                :visible.sync="wxCodeDialog"
                                width="280px">
                                <div class="textCenter" style="margin-top: -40px;">
                                    <img :src="qrcode" alt="" style="width: 240px; height: 240px;">
                                    <p>打开微信，点击底部的发现</p>
                                    <p>使用'扫一扫'即可将网页分享到朋友圈</p>
                                </div>
                                </el-dialog>

                                <div class="content-right p20">
                                    <p class="fontLight">编辑：{{ detail_info.length > 0 ? detail_info[0]['oper_man'] : '未知' }}&nbsp;&nbsp;&nbsp;&nbsp;来源: {{ detail_info.length > 0 ? detail_info[0]['sources'] : '未知' }}&nbsp;&nbsp;&nbsp;&nbsp;日期：{{ detail_info.length > 0 ? detail_info[0]['create_date'].substr(0, 10) : '' }}&nbsp;&nbsp;&nbsp;&nbsp;浏览量：{{ detail_info.length > 0 ? detail_info[0]['reading'] : '' }}</p>
                                    <p class="mw-modular-box font14 fontLight">文章标签<span class="tag pointer" v-for="(table, tableI) in detail_info[0].the_table.split(',')" :key="tableI" @click="goSearchPage(table)">{{ table }}</span></p>
                                    <div style="min-height: 670px; " class="mw-modular-box" id="qlEditorBox">
                                        <div class="mw-editor-box ql-editor"></div>
                                    </div>
                                    <small class="fontLighter">查看更多，请关注 <a href="http://www.chinatsi.com/" class="font14" style="color: rgb(0, 0, 255)">http://www.chinatsi.com/</a></small>
                                    <small class="fontLighter block" style="margin-top: 15px;">本文信息仅供参考，未经许可，不可转载。</small>
                                    <div style="display: flex; margin-top: 30px;" class="mw-modular-box content-page">
                                        <div class="pointer" style="flex: 1" @click="goDetailPage(detail_page.next[0])">
                                            <h1>上一篇</h1>
                                            <p class="font14">{{ detail_page.next.length > 0 ? detail_page.next[0]['the_title'] : '无'}}</p>
                                        </div>
                                        <div class="textRight pointer" style="flex: 1" @click="goDetailPage(detail_page.last[0])">
                                            <h1>下一篇</h1>
                                            <p class="font14 textRight">{{ detail_page.last.length > 0 ? detail_page.last[0]['the_title'] : '无' }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="grid-content">

                            <div class="inlineBlock p15 bgWhite xgtj" style="height: 239px;">
                                <h3 style="margin-bottom: 10px;" class="font16">相关推荐</h3>
                                <div class="hot-list w100 fontLight" v-for="(item, index) in consult_sel_all" :key="index" @click="goInforDetailPage(item)">
                                    <router-link :to="'/home/inforDetail/' + item.primary_id">【{{ item.type_name }}】 {{ item.the_title }}</router-link>
                                </div>
                            </div>

                            <div class="varieties-box bgWhite mw-modular-box">
                                <h3 class="font16">热门标签</h3>
                                <div class="varieties-list">
                                    <span v-for="(item, index) in label_list" :key="index" @click="goSearchPage(item.labelTxt)"><a class="fontWhite pointer">{{ item.labelTxt }}</a></span>
                                </div>
                            </div>

                            <HotRecord style="margin-top: 20px;" :ad="adIDsIndex[0] ? ( adIDsIndex[0]['list'].length > 0 ? adIDsIndex[0]['list'][0]['adPicturePath'] : '') : ''" :link="adIDsIndex[0] ? ( adIDsIndex[0]['list'].length > 0 ? adIDsIndex[0]['list'][0]['adLink'] : '') : ''"></HotRecord>

                        </div>
                    </el-col>
                </el-row>
            </div>
        </article>
        <ConcatsControl></ConcatsControl>
    </div>
</template>

<script>
import ConcatsControl from '../../templates/concatsControl'
import HotRecord from '../../templates/hotRecord'
import Vue from 'vue'
import $ from 'jquery'
import QRCode from 'qrcode'
import { baseUrl, adIDs } from '../../assets/js/common'
export default {
    name: 'Detail',
    components: { HotRecord, ConcatsControl },
    data () {
        return {
            // qqPic: require('../../assets/images/logo.png'),
            qrcode: '',
            id: '',
            detail_page: {
                last: {},
                next: {}
            },
            detail_info: {},
            share_info: {},
            isCollect: false,
            wxCodeDialog: false,
            consult_sel_all: [],
            label_list: [],
            adIDsIndex: [],
            isBefore: true
        }
    },
    mounted () {
        // 初始化内容
        this.id = this.$route.params.id;
        this.init();
    },
    watch: {
    　　'$route': function (to, from) {
            this.$router.go(0);
    　　}
    },
    methods: {
        init () {
            this.getAdByAdp();
            this.checkSave();
            this.consultFollow();
            // this.getTGraphicSel();
            this.getTGraphicSelUpDown(1); // 上一条
            this.getTGraphicSelUpDown(2); // 下一条
            this.getInfos(3, this.id);
            this.tNewsConsultSelAll();
            this.findPriorLabel();
        },

        getAdByAdp () {
            const self = this;
            self.adIDsIndex = [{
                name: 'indexRight2',
                id: adIDs['indexRight2'],
                list: []
            }];
            self.adIDsIndex.forEach((item, index) => {
                self.$get(`${baseUrl.cyw}/industriaAD/getAdByAdp?adpId=${item.id}`, {}).then(res => {
                    if (res.code == 0) {
                        self.adIDsIndex[index]['list'] = res.data;
                    }
                })
            })
        },

        // 资讯相关推荐
        tNewsConsultSelAll () {
            const self = this;
            const date = new Date();
            const edate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
            $.ajax({
                url: `${baseUrl.service}/api_v3/t_news_consult_fuzzy?pagenum=1&pernum=6`, //api_v3/t_news_consult_sel
                data: {
                    // type_name: '',
                    // big_type: '',
                    // alias_cn_name: '',
                    // the_title: '',
                    // pagenum: 1,
                    // pernum: 6,
                    // sdate: '1970-01-01',
                    // edate: edate
                },
                type: 'get',
                dataType: 'json',
                success: (res) => {
                    // if (res.code == 'ok') {
                        self.consult_sel_all = res.data;
                    // } else {
                    //     self.$message.error(res.message);
                    // }
                },
                error: () => {
                    // self.$message.error('未获取到资讯信息')
                }
            })
        },

        // 获取关键词信息
        findPriorLabel () {
            const self = this;
            self.$post(`${baseUrl.cyw}/inforLabel/findLabelList/1/12`, {labelTxt: ''}).then(res => {
                if (res.code == 0) {
                    self.label_list = res.data;
                } else {
                    self.$message.error(res.message)
                }
            }).catch(err => {
                // self.$message.error('未获取到关键词信息')
            })
        },
        goSearchPage (item) {
			debugger
            const self = this;
            self.$get(`${baseUrl.cyw}/inforLabel/addClickNum/${item}`, {}).then(res => {
                if (res.code == 0) {
                    self.$router.push(`/home/searchPage?key=${item}&type=1`)
                } else {
                    self.$message.error('跳转失败，请重试！')
                }
            }).catch(err => {
                self.$message.error('跳转失败，请重试！')
            })
        },

        // 查询用户是否收藏
        checkSave () {
            const self = this;
            const token_cyw = self.$cookies.get('token_cyw');
            if (token_cyw) {
                self.$get(`${baseUrl.business}/api/user/userByToken/${token_cyw}`, {}).then(res_1 => {
                    if (res_1.status == 200) {
                        self.$get(`${baseUrl.cyw}/inforUser/checkSave?userId=${res_1.data.id}&inforId=${self.id}`, {}).then(res => {
                            if (res.data == 'Y') {
                                self.isCollect = true;
                            }
                        })
                    } else {
                        self.$message.error(res_1.msg);
                    }
                })
            }
        },
        // 记录点击量
        consultFollow () {
            const self = this;
            $.ajax({
                url: `${baseUrl.service}/api_v3/consult_follow`,
                data: JSON.stringify({
                    "primary_id": this.id,
                    "follow": "Y",
                    "rq": "2020-01-01"
                }),
                headers: {
                    "content-type": "application/json"
                },
                type: 'post',
                dataType: 'json',
                success: (res) => {},
                error: () => {}
            })
        },
        // 记录收藏量
        consultFollowN () {
            const self = this;
            $.ajax({
                url: `${baseUrl.service}/api_v3/consult_follow`,
                data: JSON.stringify({
                    "primary_id": this.id,
                    "follow": "N",
                    "rq": "2020-01-01"
                }),
                headers: {
                    "content-type": "application/json"
                },
                type: 'post',
                dataType: 'json',
                success: (res) => {},
                error: () => {}
            })
        },

        //根据id 获取页面详情
        getTGraphicSel () {
            const self = this;
            const type = self.isBefore ? 1 : 2;
            $.ajax({
                url: `${baseUrl.service}/api_v3/t_graphic_sel/${self.id}`,
                data: {},
                type: 'get',
                dataType: 'json',
                success: (res) => {
                    if (res.code == 'ok') {
                        if (type == 1) {
                            $('.mw-editor-box').html(res.data.graphic);
                            $('.mw-editor-box table').css('width', '100%')
                        } else {
                            $.ajax({
                                url: `${baseUrl.informationFF}/API_V1/NEWS/newsdata?NEWS_ID=${self.id}`,
                                data: {},
                                type: 'get',
                                dataType: 'json',
                                success: (res_1) => {
                                    if (res_1.code == 'ok') {
                                        $('.mw-editor-box').html(res_1.data);
                                        $('.mw-editor-box table').css('width', '100%')
                                    } else {
                                        self.$message.error(res_1.message);
                                    }
                                },
                                error: () => {
                                    // self.$message.error('未获取到详情信息')
                                }
                            })

                        }
                        self.share_info['base_file'] = res.data.base_file;
                        $('#qlEditorBox').height($('.mw-editor-box').height() + 40);
                    } else {
                        self.$message.error(res.message);
                    }
                },
                error: () => {
                    // self.$message.error('未获取到详情信息')
                }
            })
        },

        // 获取上一条
        getTGraphicSelUpDown (type) {
            const self = this;
            const url = type == 1 ? `${baseUrl.service}/api_v3/t_tnews_consult_up?primary_id=${self.id}` : `${baseUrl.service}/api_v3/t_tnews_consult_down?primary_id=${self.id}`;
            $.ajax({
                url: url,
                data: {},
                type: 'get',
                dataType: 'json',
                success: (res) => {
                    if (res.code == 'ok') {
                        // self.getInfos(type, res.data.primary_id);
                        if (type == 1) {
                            self.detail_page.last = res.data;
                        } else if (type == 2) {
                            self.detail_page.next = res.data;
                        }
                    } else {
                        // self.$message.error(res.message);
                    }
                },
                error: () => {
                    // self.$message.error('未获取到详情信息')
                }
            })
        },
        // 获取信息
        getInfos (type, id) {
            const self = this;
            $.ajax({
                url: `${baseUrl.service}/api_v3/t_news_consult_sel_primary?primary_id=${id}`,
                data: {},
                type: 'get',
                dataType: 'json',
                success: (res) => {
                    if (res.code == 'ok') {
                        if (type == 1) {
                            self.detail_page.last = res.data;
                        } else if (type == 2) {
                            self.detail_page.next = res.data;
                        } else {
                            self.detail_info = res.data;
                            self.share_info['the_title'] = res.data[0]['the_title'];
                            self.share_info['overview'] = res.data[0]['overview'];
                            self.compareDate(res.data[0].create_date);
                            self.getTGraphicSel();
                        }
                    } else {
                        self.$message.error(res.message);
                    }
                },
                error: () => {
                    // self.$message.error('未获取到详情信息')
                }
            })
        },

        // 添加/取消收藏
        handleCollect () {
            const self = this;
            const token_cyw = self.$cookies.get('token_cyw');
            if (token_cyw) {
                
                self.$get(`${baseUrl.business}/api/user/userByToken/${token_cyw}`, {}).then(res_1 => {
                    if (res_1.status == 200) {
                        if (!self.isCollect) {
                            const param = { crmUserId: res_1.data.id, inforId: self.id, inforTypeId: self.detail_info[0]['consult_id'] }
                            self.$post(`${baseUrl.cyw}/inforUser/save`, param).then(res => {
                                if (res.code == 0) {
                                    self.consultFollowN();
                                    self.$message('收藏成功');
                                    self.isCollect = true;
                                } else {
                                    self.$message.error(res.message)
                                }
                            })
                        } else { // 已经收藏过了
                            self.$get(`${baseUrl.cyw}/inforUser/del?userId=${res_1.data.id}&inforId=${self.id}`, {}).then(res => {
                                if (res.code == 0) {
                                    self.$message('取消收藏成功');
                                    self.isCollect = false;
                                } else {
                                    self.$message.error(res.message)
                                }
                            })
                        }
                    } else {
                        self.$confirm(res_1.msg, '提示', {
                            confirmButtonText: '确定',
                            showCancelButton: false,
                            type: 'error'
                        }).then(() => {
                            self.$router.go(0)
                        })
                    }
                }).catch(err_1 => {
                    self.$confirm('未获取到用户信息，请重新登录', '提示', {
                        confirmButtonText: '确定',
                        showCancelButton: false,
                        type: 'error'
                    }).then(() => {
                        self.$router.go(0)
                    })
                })
            } else {
                self.$message({
                    message: '请登录后收藏',
                    type: 'warning'
                })
            }
        },

        // 标签链接到搜索结果页
        goSearchPage (name) {
            this.$router.push(`/home/searchPage?key=${name}&type=1`);
        },

        // 上一篇/下一篇
        goDetailPage (item) {
            if (item) {
                this.$router.push(`/home/inforDetail/${item.primary_id}`);
            }
        },

        goInforDetailPage (param) { // 跳转到资讯详情页
            this.$router.push(`/home/inforDetail/${param.primary_id}`)
        },

        // 分享到QQ
        shareToqq (event) {
            const self = this;
            let url = window.location.href;
            // let index = url.indexOf('http://') ? 6 : (url.indexOf('https://') ? 7 : 0);
            // url = url.substr(index, url.length)
            let p = {
                 url: url,
                //  showcount: '0',/*是否显示分享总数,显示：'1'，不显示：'0' */
                 desc: '',/*默认分享理由(可选)  */
                 summary: self.share_info['overview'],/*分享摘要(可选) */
                 title: self.share_info['the_title'],/*分享标题(可选)*/
                //  site: '',/*分享来源 如：腾讯网(可选)*/
                //  pics: 'data:image/png;base64' + self.share_info['base_file'], /*分享图片的路径(可选)*/
                //  style: '101',
                //  width: 199,
                //  height: 30
            };
            window.open(`https://connect.qq.com/widget/shareqq/index.html?url=${p.url}?sharesource=qzone&title=${p.title}&pics=&summary=${p.summary}&desc=${p.desc}`);
        },

        // 分享到微信
        showDetailCode () {
            const self = this;
            // const url = window.location.origin + window.location.pathname + '#/inforDetailP/' + self.id;
            self.$get(`${baseUrl.informationShare}/tenxSteel/v2/info/getAppId?infoId=${self.id}`, {}).then(res => {
                const url = window.location.origin + '/phone/index.html?id=' + self.id + '&appid=' + res.data;
                QRCode.toDataURL(url).then(imgData => {
                    if(imgData) {
                        self.qrcode = imgData;
                    }
                });
                self.wxCodeDialog = true;
            }).catch(err => {
                const url = window.location.origin + '/phone/index.html?id=' + self.id + '&appid=500';
                QRCode.toDataURL(url).then(imgData => {
                    if(imgData) {
                        self.qrcode = imgData;
                    }
                });
                self.wxCodeDialog = true;
            })
            
        },

        // 对比日期，4月1日之前的用t_graphic_sel, 之后的用newsdata
        compareDate (_date) {
            const times = new Date('2020-04-03').getTime();
            const dateTimes = new Date(_date).getTime();
            if (times >= dateTimes) {
                this.isBefore = true;
            } else {
                this.isBefore = false;
            }
        }
        
    },
}
</script>

<style scoped>
    .content-box { display: flex; }
    .content-left { flex: 1; padding-top: 20px; }
    .content-right { flex: 8; }
    .infor-detail-box .tag { border: 1px solid #eee; border-radius: 15px; padding: 1px 10px; color: #a30000; display: inline-block; margin-left: 10px; }
    .content-page h1 { font-size: 22px; }
    .content-page p { 
        line-height: 24px; margin-top: 15px;
        text-overflow:ellipsis;
        white-space: nowrap;
        overflow: hidden;
        width: 320px;
    }
    .use { display: none; }
    .make-icon:hover > .use { display: block; }
    .show { display: block !important; }
    .hot-list { 
        height: 35px;
        line-height: 35px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
    }
    .varieties-box { padding: 10px; margin-bottom: 20px; }
    .varieties-box h4 { display: flex; }
    .varieties-box h4 span { flex: 1; }
    .varieties-box > .varieties-list { padding: 20px 0 0 0; }
    .varieties-box > .varieties-list a { display: inline-block; padding: 10px 18px; margin-right: 8px; margin-bottom: 20px; border-radius: 3px; background: #a30000; }
</style>